import { render, staticRenderFns } from "./created.vue?vue&type=template&id=4ed4c23c&scoped=true&"
import script from "./created.vue?vue&type=script&lang=js&"
export * from "./created.vue?vue&type=script&lang=js&"
import style0 from "./created.css?vue&type=style&index=0&id=4ed4c23c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed4c23c",
  null
  
)

export default component.exports